import type { Activite } from './Activite.definitions.js';

export const libellesActivites: Record<Activite, string> = {
  acteurDuMarche:
    "Acteurs du marché fournissant des services d'agrégation, de " +
    "participation active de la demande ou de stockage d'énergie",
  autoritesRoutieresControleGestionCirculation:
    'Autorités routières chargées du contrôle de la gestion de la ' +
    "circulation, à l'exclusion des entités publiques pour lesquelles la " +
    "gestion de la circulation ou l'exploitation de systèmes de transport " +
    'intelligents constituent une partie non essentielle de leur activité ' +
    'générale',
  autreActiviteConstructionVehiculesAutomobilesRemorquesSemi: 'Autre activité',
  autreActiviteEauPotable: 'Autre activité',
  autreActiviteEauxUsees: 'Autre activité',
  autreActiviteElectricite: 'Autre activité',
  autreActiviteEspace: 'Autre activité',
  autreActiviteFabricationDispositifsMedicaux: 'Autre activité',
  autreActiviteFabricationEquipementsElectroniques: 'Autre activité',
  autreActiviteFabricationMachinesEquipements: 'Autre activité',
  autreActiviteFabricationProductionDistributionProduitsChimiques: 'Autre activité',
  autreActiviteFabricationProduitsInformatiquesElectroniquesOptiques: 'Autre activité',
  autreActiviteFournisseursNumeriques: 'Autre activité',
  autreActiviteGaz: 'Autre activité',
  autreActiviteGestionDechets: 'Autre activité',
  autreActiviteGestionServicesTic: 'Autre activité',
  autreActiviteHydrogene: 'Autre activité',
  autreActiviteInfrastructureMarcheFinancier: 'Autre activité',
  autreActiviteInfrastructureNumerique: 'Autre activité',
  autreActivitePetrole: 'Autre activité',
  autreActiviteProductionTransformationDistributionDenreesAlimentaires: 'Autre activité',
  autreActiviteRecherche: 'Autre activité',
  autreActiviteReseauxChaleurFroid: 'Autre activité',
  autreActiviteSante: 'Autre activité',
  autreActiviteSecteurBancaire: 'Autre activité',
  autreActiviteServicesPostauxExpedition: 'Autre activité',
  autreActiviteTransportsAeriens: 'Autre activité',
  autreActiviteTransportsFerroviaires: 'Autre activité',
  autreActiviteTransportsParEaux: 'Autre activité',
  autreActiviteTransportsRoutiers: 'Autre activité',
  collectantEvacuantTraitantEaux:
    'Entreprises collectant, évacuant ou traitant les eaux urbaines ' +
    'résiduaires, les eaux ménagères usées ou les eaux industrielles usées, ' +
    "à l'exclusion des entreprises pour lesquelles la collecte, l'évacuation " +
    'ou le traitement des eaux urbaines résiduaires, des eaux ménagères ' +
    'usées ou des eaux industrielles usées constituent une partie non ' +
    'essentielle de leur activité générale',
  constructionAeronautiqueSpatiale:
    'Construction aéronautique et spatiale ' +
    '- Construction aéronautique et spatiale civile ' +
    '- Construction aéronautique et spatiale militaire',
  constructionBateauxNaviresMilitaires: 'Construction de bateaux et navires militaires',
  constructionBateauxPlaisance: 'Construction de bateaux de plaisance',
  constructionLocomotivesAutreMaterielFerroviaireRoulant:
    "Construction de locomotives et d'autre matériel ferroviaire roulant",
  constructionNavale: 'Construction navale',
  constructionNaviresStructuresFlottantesCiviles: 'Construction de navires et de structures flottantes civiles',
  constructionVehiculeMilitaireCombat: 'Construction de véhicules militaires de combat',
  constructionVehiculesAutomobiles: 'Construction de véhicules automobiles',
  contrepartieCentrales: 'Contreparties centrales',
  entiteCentralesStockage: 'Entités centrales de stockage',
  entiteGestionnaireAeroports:
    "Entités gestionnaires d'aéroports, aéroports, " +
    'y compris les aéroports du réseau central, et entités exploitant les ' +
    'installations annexes se trouvant dans les aéroports',
  entiteGestionnairePorts:
    'Entités gestionnaires des ports, y compris les ' +
    'installations portuaires, ainsi que les entités exploitant des ' +
    "infrastructures et des équipements à l'intérieur des ports",
  entrepriseElectriciteRemplissantFonctionFourniture: "Entreprise d'électricité remplissant une fonction de fourniture",
  entrepriseFerroviaire: "Entreprises ferroviaires, y compris les exploitants d'installation de " + 'service',
  entrepriseFourniture: 'Entreprises de fourniture',
  etablissementCredit: 'Établissements de crédit',
  executantOperationGestionDechets:
    'Entreprises exécutant des opérations de gestion des déchets, à ' +
    "l'exclusion des entreprises pour lesquelles la gestion des déchets " +
    "n'est pas la principale activité économique",
  exploitantsInfrastructureTerrestresFournitureServicesSpaciaux:
    "Exploitants d'infrastructures terrestres, détenues, gérées et " +
    'exploitées par des États membres ou par des parties privées, qui ' +
    "soutiennent la fourniture de services spatiaux, à l'exclusion des " +
    'fournisseurs de réseaux de communications électroniques publics',
  exploitantsInstallationPetrole:
    "Exploitants d'installations de production, de raffinage, de traitement, " +
    'de stockage et de transport de pétrole',
  exploitantsOleoduc: "Exploitants d'oléoducs",
  exploitantsPlateformesNegociation: 'Exploitants de plates-formes de négociation',
  exploitantsPointRecharge:
    "Exploitants d'un point de recharge qui sont responsables de la gestion " +
    "et de l'exploitation d'un point de recharge, lequel fournit un service " +
    'de recharge aux utilisateurs finals, y compris au nom et pour le compte ' +
    "d'un prestataire de services de mobilité",
  exploitantsServiceTrafficMaritime: 'Exploitants de services de trafic maritime (STM)',
  exploitantsSystemeHydrogene: 'Exploitants de systèmes de production, de stockage et de transport ' + "d'hydrogène",
  exploitantsSystemeTransportIntelligents: 'Exploitants de systèmes de transport intelligents',
  fabricationDistributionSubstances:
    'Entreprises procédant à la fabrication de substances et à la ' +
    'distribution de substances ou de mélanges et entreprises procédant ' +
    "à la production d'articles, à partir de substances ou de mélanges",
  fabricationMaterielTransportNCA:
    'Fabrication de matériels de transport n.c.a. ' +
    '- Fabrication de motocycles ' +
    '- Fabrication de bicyclettes et de véhicules pour invalides ' +
    "- Fabrication d'autres équipements de transport n.c.a.",
  fabriquantAppareilEclairage: "Fabrication d'appareils d'éclairage",
  fabriquantAppareilsMenagers:
    "Fabrication d'appareils ménagers " +
    "- Fabrication d'appareils électroménagers " +
    "- Fabrication d'appareils ménagers non électriques",
  fabriquantAutresMachinesUsageGeneral:
    "Fabrication d'autres machines d'usage général " +
    "- Fabrication de fours et brûleurs et d'équipements fixes de chauffage " +
    'domestique ' +
    '- Fabrication de matériel de levage et de manutention ' +
    "- Fabrication de machines et d'équipements de bureau (à l'exception " +
    'des ordinateurs et équipements périphériques) ' +
    "- Fabrication d'outillage portatif à moteur incorporé " +
    "- Fabrication d'équipements aérauliques et frigorifiques industriels " +
    "- Fabrication de machines diverses d'usage général",
  fabriquantAutresMachinesUsageSpecifiqueNCA:
    "Fabrication d'autres machines d'usage spécifique " +
    '- Fabrication de machines pour la métallurgie ' +
    "- Fabrication de machines pour l'extraction ou la construction " +
    "- Fabrication de machines pour l'industrie agroalimentaire " +
    '- Fabrication de machines pour les industries textiles et du cuir ' +
    '- Fabrication de machines pour les industries du papier et du carton ' +
    '- Fabrication de machines pour le travail du caoutchouc ou des ' +
    'plastiques ' +
    '- Fabrication de machines de fabrication additive ' +
    "- Fabrication d'autres machines d'usage spécifique n.c.a.",
  fabriquantCarrosseriesVehiculesAutomobiles:
    'Fabrication de carrosseries de véhicules automobiles; fabrication de ' + 'remorques et de semi-remorques',
  fabriquantComposantCartesElectroniques:
    'Fabrication de composants et cartes électroniques ' +
    '- Fabrication de composants électroniques ' +
    '- Fabrication de cartes électroniques assemblées',
  fabriquantDispositifsMedicaux:
    'Entités fabriquant des dispositifs médicaux et entités fabriquant des ' +
    "dispositifs médicaux de diagnostic in vitro, à l'exception des entités " +
    "fabriquant des dispositifs médicaux mentionnés à l'annexe I, point 5, " +
    'cinquième tiret, de la présente directive',
  fabriquantDispositifsMedicauxCritiques:
    'Entités fabriquant des dispositifs médicaux considérés comme critiques ' + "en cas d'urgence de santé publique",
  fabriquantEquipementCommunication: "Fabrication d'équipements de communication",
  fabriquantEquipementIrradiationMedicaleElectromedicauxElectrotherapeutiques:
    "Fabrication d'équipements d'irradiation médicale, d'équipements " + 'électromédicaux et électrothérapeutiques',
  fabriquantEquipementsAutomobiles:
    "Fabrication d'équipements automobiles " +
    "- Fabrication d'équipements électriques et électroniques automobiles " +
    "- Fabrication d'autres équipements automobiles",
  fabriquantFilsCablesMaterielInstallationElectrique:
    "Fabrication de fils et câbles et de matériel d'installation électrique " +
    '- Fabrication de câbles de fibres optiques ' +
    "- Fabrication d'autres fils et câbles électroniques ou électriques " +
    "- Fabrication de matériel d'installation électrique",
  fabriquantInstrumentsMesureEssaiNavigationHorlogerie:
    "Fabrication d'instruments de mesure, d'essai et de navigation ; horlogerie",
  fabriquantMachineEquipementNCA: 'Fabrication de machines et équipements n.c.a.',
  fabriquantMachineUsageGeneral:
    "Fabrication de machines d'usage général " +
    "- Fabrication de moteurs et turbines, à l'exception des moteurs d'avions et de véhicules " +
    "- Fabrication d'équipements hydrauliques et pneumatiques " +
    "- Fabrication d'autres pompes et compresseurs " +
    "- Fabrication d'autres articles de robinetterie " +
    "- Fabrication d'engrenages et d'organes mécaniques de transmission",
  fabriquantMachinesAgricolesForestieres: 'Fabrication de machines agricoles et forestières',
  fabriquantMachinesFormageMetauxMachinesOutils: 'Fabrication de machines de formage des métaux et de machines-outils',
  fabriquantMaterielOptiquePhotographiquesSupportsMagnetiquesOptiques:
    'Fabrication de matériels optique et photographique et de supports ' + 'magnétiques et optiques',
  fabriquantMoteursGeneratriceTransformation:
    'Fabrication de moteurs, génératrices et transformateurs électriques et ' +
    'de matériel de distribution et de commande électrique',
  fabriquantOrdinateursEquipementsPeripheriques: "Fabrication d'ordinateurs et d'équipements périphériques",
  fabriquantPilesAccumulateursElectriques: "Fabrication de piles et d'accumulateurs électriques",
  fabriquantProduitPreparationsPharmaceutiques:
    'Entités fabriquant des produits pharmaceutiques de base et des ' + 'préparations pharmaceutiques',
  fabriquantProduitsElectroniquesGrandPublic: 'Fabrication de produits électroniques grand public',
  fabriquantProduitsInformatiquesElectroniquesOptiques:
    'Fabrication de produits informatiques, électroniques et optiques',
  fournisseurPointEchangeInternet: "Fournisseur de points d'échange internet",
  fournisseurReseauxCommunicationElectroniquesPublics: 'Fournisseur de réseaux de communications électroniques publics',
  fournisseurReseauxDiffusionContenu: 'Fournisseur de réseaux de diffusion de contenu',
  fournisseurServiceCentresDonnees: 'Fournisseur de services de centres de données',
  fournisseurServiceCommunicationElectroniquesPublics:
    'Fournisseur de services de communications électroniques accessibles au public',
  fournisseurServicesDNS:
    "Fournisseur de services DNS, à l'exclusion des opérateurs de serveurs racines de noms de domaines",
  fournisseurServicesGeres: 'Fournisseur de services gérés',
  fournisseurServicesInformatiqueNuage: "Fournisseur de services d'informatique en nuage",
  fournisseurServicesSecuriteGeres: 'Fournisseur de services de sécurité gérés',
  fournisseursDistributeursEauxConsommation:
    "Fournisseurs et distributeurs d'eaux destinées à la consommation " +
    "humaine, à l'exclusion des distributeurs pour lesquels la distribution " +
    "d'eaux destinées à la consommation humaine constitue une partie non " +
    "essentielle de leur activité générale de distribution d'autres produits " +
    'et biens',
  fournisseursMoteursRechercheEnLigne: 'Fournisseur de moteurs de recherche en ligne',
  fournisseursPlaceMarcheEnLigne: 'Fournisseur de places de marché en ligne',
  fournisseursPlateformesServicesReseauxSociaux: 'Fournisseur de plateformes de services de réseaux sociaux',
  fournisseurServicesEnregristrementNomDomaine: "Fournisseur des services d'enregistrement de noms de domaine",
  gestionnaireInfrastructure: 'Gestionnaires des infrastructures',
  gestionnaireInstallationGNL: "Gestionnaires d'installation de GNL",
  gestionnaireInstallationStockage: "Gestionnaires d'installation de stockage",
  gestionnaireReseau: 'Gestionnaire de réseau de distribution',
  gestionnaireReseauDistribution: 'Gestionnaires de réseau de distribution',
  gestionnaireReseauTransportGaz: 'Gestionnaire de réseau de transport',
  gestionnaireReseauTransportElectricite: 'Gestionnaire de réseau de transport',
  laboratoireReferenceUE: "Laboratoires de référence de l'Union européenne",
  operateurDesigneMarcheOuNemo: 'Opérateur désigné du marché ou NEMO',
  operateurReseauChaleurFroid: 'Opérateurs de réseaux de chaleur ou de réseaux de froid',
  organismeRecherche: 'Organismes de recherche',
  prestataireServiceConfianceQualifie: 'Prestataire de service de confiance qualifié',
  prestataireServiceConfianceNonQualifie: 'Prestataire de service de confiance non qualifié',
  prestataireSoinsSante: 'Prestataires de soins de santé',
  prestatairesServicesPostauxExpedition:
    'Prestataires de services postaux, y compris les prestataires de ' + "services d'expédition",
  producteur: 'Producteurs',
  rechercheDeveloppementMedicament:
    'Entités exerçant des activités de recherche et de développement dans le ' + 'domaine des médicaments',
  registresNomsDomainesPremierNiveau: 'Registre de noms de domaines de premier niveau',
  secteurAlimentaireDistributionGrosProductionTransformationIndustrielle:
    'Entreprises du secteur alimentaire qui exercent des activités de ' +
    'distribution en gros ainsi que de production et de transformation ' +
    'industrielles',
  serviceControleCirculationAerienne: 'Services du contrôle de la circulation aérienne',
  societeTransportEaux:
    "Sociétés de transport par voie d'eau intérieure, maritime et côtier de " +
    "passagers et de fret, à l'exclusion des navires exploités à titre " +
    'individuel par ces sociétés',
  transporteursAeriensCommercial: 'Transporteurs aériens à des fins commerciales',
};
